export enum FieldTypes {
  Date = 'Date',
  DateTime = 'DateTime',
  Text = 'Text',
  Checkbox = 'Checkbox',
  Number = 'Number',
  Amount = 'Amount',
  Dropdown = 'Dropdown',
  LongText = 'LongText',
  Notes = 'Notes',
  Email = 'Email',
  File = 'File',
  Percentage = 'Percentage',
  Phone = 'Phone',
  Signature = 'Signature',
  Formula = 'Formula',
}

export enum ViewMode {
  FUNNEL = 'funnel',
  DOC = 'doc',
  DEFAULT = 'default',
}

export enum Integration {
  Community = 'community',
  Salesforce = 'salesforce',
  SmartWe = 'smartwe',
  HubSpot = 'hubspot',
  MicrosoftDynamics = 'msdynamics',
}

/**
 * Enum for the output modes of the AI widgets (where to display the generated text).
 * @story User Story 10482: Generic Prompt AI widget: select output mode: add or replace
 */
export enum WidgetOutputMode {
  /** Append the generated text under the widget */
  Add = 'Add',
  /** Replace the recommendation text with the generated text (#10482) */
  Replace = 'Replace',
}

/**
 * Realtime model presets supported by the AI Teammate widget.
 */
export enum AiTeammateRealtimeModel {
  GptRealtime15 = 'gpt-realtime-1.5',
  GptRealtime2 = 'gpt-realtime-2',
  GptRealtime2Thinking = 'gpt-realtime-2-thinking',
  GptRealtimeMini = 'gpt-realtime-mini',
}

/**
 * Expected speech language for AI Teammate transcription (re-exported to share the type with core interfaces)
 */
export { AiTeammateTranscriptionLanguage } from '@playbooks/core/src/interfaces/ActionCard'

/**
 * Enum for the types of object state.
 */
export enum ObjectStateType {
  IsTagSet = 'IsTagSet',
}
